import { render, staticRenderFns } from "./AlPopover.vue?vue&type=template&id=5272555e&"
import script from "./AlPopover.vue?vue&type=script&lang=js&"
export * from "./AlPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports